import { render, staticRenderFns } from "./TextImage1.vue?vue&type=template&id=a3e1fb62&scoped=true"
import script from "./TextImage1.vue?vue&type=script&lang=js"
export * from "./TextImage1.vue?vue&type=script&lang=js"
import style0 from "./TextImage1.vue?vue&type=style&index=0&id=a3e1fb62&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3e1fb62",
  null
  
)

export default component.exports